module.exports = __webpack_public_path__ + "static/2-9aed3a6e1089cb3bda0b82d6e993ed41.jpg";